export default {
  add: 'Add',
  addAnotherCompany: 'Add another company',
  addCompany: 'Add a company',
  addPhoto: 'Add a photo',
  addService: 'Add a service',
  back: 'Back',
  close: 'Close',
  delete: 'Delete',
  detail: 'Show',
  edit: 'Edit',
  editPhoto: 'Change a photo',
  forgotPassword: 'Forgot password?',
  switchLanguage: 'Change language',
  login: 'Log in',
  logout: 'Log out',
  logoutConfirm: 'Are you sure you want to log out?',
  no: 'No',
  ok: 'OK',
  register: 'Sign up',
  remove: 'Remove',
  resendEmail: 'Send email',
  save: 'Save',
  send: 'Send',
  select: 'Select',
  yes: 'Yes',
  upload: 'Upload',
  continue: 'Continue'
}



// WEBPACK FOOTER //
// ./src/i18n/en/actions.js